import React from 'react'
import { Form } from 'react-bootstrap'

export default function TaskTemplateForm({ taskTemplate, register, errors }) {
	return (
		<React.Fragment>
			<Form.Group>
				<Form.Label>Nombre de Tarea <span className="text-danger">*</span></Form.Label>
				<Form.Control 
					{...register("name", {required: true})} 
					defaultValue={taskTemplate && taskTemplate.name} 
				/>
				{ errors.name && <Form.Text className="text-warning">Este campo es requerido.</Form.Text> }
			</Form.Group>
			<Form.Group>
				<Form.Label>Descripción <span className="small text-muted">(opcional)</span></Form.Label>
				<Form.Control 
					{...register("description", {})} 
					defaultValue={taskTemplate && taskTemplate.description} 
					as="textarea"
				/>
			</Form.Group>
			<Form.Group>
				<Form.Label>Frecuencia <span className="small text-muted">(opcional)</span></Form.Label>
				<Form.Control as="select" {...register('frequency',{})} defaultValue={taskTemplate && taskTemplate.frequency}>
					<option value="">:: Seleccione una opción ::</option>
					<option>Diario</option>
					<option>Semanal</option>
					<option>Quincenal</option>
					<option>Mensual</option>
					<option>Bimestral</option>
					<option>Trimestral</option>
					<option>Semestral</option>
					<option>Anual</option>
				</Form.Control>
			</Form.Group>
			<Form.Group>
				<Form.Label>Estado <span className="text-danger">*</span></Form.Label>
				<Form.Control as="select" {...register('active',{required:true})} defaultValue={taskTemplate && taskTemplate.active}>
					<option value="1">Activo</option>
					<option value="0">Inactivo</option>
				</Form.Control>
			</Form.Group>
		</React.Fragment>
	)
}